import { Pipe, PipeTransform } from '@angular/core';

@Pipe({name: 'iban'})
export class IbanPipe implements PipeTransform {
    weights: number[] = [12, 73, 17, 89, 38, 62, 45, 53, 15, 50, 5, 49, 34, 81, 76, 27, 90, 9, 30, 3, 10, 1];

    transform(value: string): string {
       const nib = '0018' + value;

       if (nib.length < 25) {
            if (nib.length !== 19) {
                return value;
            }

            let sum = 0;
            const aux_number = '0' + nib;

            for (let i = 0; i < 20; i++) {
                sum += this.weights[i] * Number(aux_number.charAt(i));
            }

            const checkDigits = `` + (98 - (sum % 97));
            let iban = `PT50`;
            iban += nib;

            if (checkDigits.length < 2) {
                iban += `0` + checkDigits;
            } else {
                iban += checkDigits;
            }

            return this.formatIban(iban);
        } else {
            return this.formatIban(value);
        }
      }

      formatIban(iban: string): string {
        const separator = ' ';
        const country = iban.substring(0, 4);
        const bank = iban.substring(4, 8);
        const account =  iban.substring(8, 25);

        return country.concat(separator).concat(bank).
                       concat(separator).concat(account.substring(0, 15)).
                       concat(separator).concat(account.substring(15));
      }
}
